import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/config/descuentos';
import CrearDescuento from './CrearDescuento';


const ms2p = (state) => {
    return {
        ...state.descuentos,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearDescuento);
